import React, { useState } from "react";
import PropTypes from "prop-types";

const InlineRename = ({ initial, onSave, onCancel, placeholder }) => {
  const [draft, setDraft] = useState(initial || "");
  return (
    <span className="flex items-center gap-1">
      <input
        autoFocus
        aria-label="friendly name"
        placeholder={placeholder}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        className="border border-border rounded-ctrl px-2 py-0.5 text-sm"
      />
      <button
        type="button"
        onClick={() => onSave(draft.trim())}
        className="text-primary text-xs underline"
      >
        Save
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="text-text-3 text-xs underline"
      >
        Cancel
      </button>
    </span>
  );
};

InlineRename.propTypes = {
  initial: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default InlineRename;
